<template>
  <div>
    <p>
      I have been working in developing for more than two years now,
      starting from Java desktop application development to web application 
      development using Laravel. I have expired not only developing but also 
      in requirement gathering, analyzing, implementation, and user training.
    </p>
    <br>
    <p>
     I ❤ coding and I like to keep my code clean. 
     I believe that there is always a simple and clean approach when it comes to coding. A clean block of code, always makes me happy 😃 . 
    </p>
    <br>
    <div class="is-hidden-desktop is-hidden-widescreen is-hidden-tablet is-hidden-fullhd ">
      <cham-side-image/>
    </div>
    <br>
    <p>
      I like exploring new technologies that challenge me to reach the best of myself as a developer.
      I think that reflects in my applications as well; making them the best solution.
    </p>
  </div>
</template>

<script>
  export default {
    name : 'AboutMe'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/componests/AboutMe.vue